(function() {
    var currentPath = window.location.pathname.replace(/\/+$/, '') + '/';
    var mapLinks = document.querySelectorAll('#us-map a.state, #canada-map a.province-link');
    if (!mapLinks.length) return;

    function getPathFromLink(link) {
        var rawHref = link.getAttribute('href') || link.getAttribute('xlink:href');
        if (!rawHref || rawHref.indexOf('#') === 0) return '';
        try {
            var parsed = new URL(rawHref, window.location.origin);
            return parsed.pathname.replace(/\/+$/, '') + '/';
        } catch (e) {
            return '';
        }
    }

    mapLinks.forEach(function(link) {
        var linkPath = getPathFromLink(link);
        if (linkPath && linkPath === currentPath) {
            link.classList.add('is-active');
            link.setAttribute('aria-current', 'page');
        }
    });
})();